import { routeObserver } from '@src/common/util/routeObserver';
import { riskScoresFilterPanelsApi } from './riskScoresFilterPanel.state';

routeObserver.observeRiskScoresEnter(async () => {
  await riskScoresFilterPanelsApi.onRouteEnter();
});
